// extracted by mini-css-extract-plugin
export default {"container":"result-screen_container__6Wnxn","title":"result-screen_title__gXFMj","description":"result-screen_description__jXNEE"};